import { FC } from 'react';
import VendorList from '../components/vendors/VendorList';
import { WrapInLayout } from '../layouts';

const VendorsPage: FC = () => (
  <WrapInLayout title="Vendors" layout="portal">
    <VendorList />
  </WrapInLayout>
);

export default VendorsPage;
